import { render } from "./NavigationTable.vue?vue&type=template&id=4c0345cb"
import script from "./NavigationTable.vue?vue&type=script&lang=js"
export * from "./NavigationTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__